import { Grid } from "@mui/material";
import React, { useEffect, useCallback } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Button,
  Box,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
// import AddNewClient from "../../../../Components/Broker/Client/AddNewClientSP/AddNewClient";
import BulkUploadForm from "../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import AddNewClient from "../Clients/AddNewClient/AddNewClient";
import BulkUploadPage from "../BulkUpload/BulkUploadPage";
import { ALL_ROUTES } from "../../../../Routes/all_routes";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";

interface Props {
  addClient: boolean;
}

const Clients: React.FC<Props> = ({ addClient }) => {
  const [addFilterStatus, setAddFilterStatus] = React.useState(false);
  const [addNewClient, setAddNewClient] = React.useState(addClient);
  const [editClient, setEditClient] = React.useState(false);
  const [addNewClientStep, setaddNewClientStep] = React.useState(1);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [policyType, setPolicyType] = React.useState("");
  const [policyname, setPolicyName] = React.useState("");
  const [expiry, setExpiryStatus] = React.useState("");

  const [age, setAge] = React.useState("");
  const [states, setStates] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [gender, setGender] = React.useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey && event.keyCode == 67) {
        setAddNewClient(true);
      }
    }
  }, []);

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
    } else if (attrName === "policyType") {
      setPolicyType(event.target.value as string);
    } else if (attrName === "expiry") {
      setExpiryStatus(event.target.value as string);
    } else if (attrName === "policyname") {
      setPolicyName(event.target.value as string);
    } else if (attrName === "states") {
      setStates(event.target.value as string);
    }
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 2,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#2166AA" : "#308fe8",
    },
  }));

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "client_id",
      headerName: "Client ID",
      width: 100,
      check_status: true,

      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/ClientDetails");
            }}
          >
            EV1001
          </p>
        );
      },
    },
    {
      field: "company_name",
      headerName: "Organization",
      width: 150,
      check_status: true,
    },
    {
      field: "ownership",
      headerName: "Ownership",
      width: 150,
      check_status: true,
    },
    {
      field: "industry_type",
      headerName: "Industry",
      width: 100,
      check_status: true,
    },
    {
      field: "sub_industry",
      headerName: "Sub Industry",
      width: 100,
      check_status: true,
    },
    {
      field: "locations",
      headerName: "No. of Locations",
      width: 150,
      check_status: true,
    },
    {
      field: "reg_address",
      headerName: "Registered Address",
      width: 300,
      check_status: true,
    },
    {
      field: "org_contact",
      headerName: "Organization Phone no.",
      width: 150,
      check_status: true,
    },
    {
      field: "noe",
      headerName: "Number of employees",
      width: 150,
      check_status: true,
    },
    {
      field: "active_policies",
      headerName: "Active Policies",
      width: 100,
      check_status: true,
    },
    {
      field: "spoc",
      headerName: "SPOC",
      width: 100,
      check_status: true,
    },
    {
      field: "website",
      headerName: "Website",
      width: 200,
      check_status: true,
    },
    {
      field: "org_email",
      headerName: "Orgnization Email",
      width: 250,
      check_status: true,
    },
    {
      field: "emp_portal",
      headerName: "Employer Portal",
      width: 150,
      check_status: true,
    },
    {
      field: "employee_portal",
      headerName: "Employee Portal",
      width: 150,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      client_id: "EV2320",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "3",
      reg_address: "Building No. 341 4th Floor,Phase 9 Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "232",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 1,
      client_id: "EV2321",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "3",
      reg_address:
        "Building No. 341 4th Floor,Phase 9, sector-65, Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "232",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 2,
      client_id: "EV2322",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "3",
      reg_address: "Building No. 341 4th Floor,Phase 9 Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "232",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 3,
      client_id: "EV2323",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "3",
      reg_address:
        "Building No. 341 4th Floor,Phase 9, sector-65, Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "232",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 4,
      client_id: "EV2324",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "30",
      reg_address: "Building No. 341 4th Floor,Phase 9 Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "2302",
      active_policies: "6",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 5,
      client_id: "EV2325",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "85",
      reg_address:
        "Building No. 341 4th Floor,Phase 9, sector-65, Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "2532",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
    {
      id: 6,
      client_id: "EV2326",
      company_name: "Evervent",
      ownership: "Pvt.Ltd",
      industry_type: "IT",
      sub_industry: "Software",
      locations: "3",
      reg_address: "Building No. 341 4th Floor,Phase 9 Mohali(160062)",
      org_contact: "+91-0000000000",
      noe: "232",
      active_policies: "4",
      spoc: "9746325414 - Suveshi",
      website: "https://evervent.in",
      org_email: "ev@evervent.com",
      emp_portal: "Yes",
      employee_portal: "No",
    },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  return (
    <Grid container spacing={2}>
      {/* Bulk upload */}
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />

      {/* Filter */}
      <Modal open={addFilterStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              />
              <h5 className="popup-heading">Add Filters</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2} textAlign="center">
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Client ID</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Client ID"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>001</MenuItem>
                  <MenuItem value={"22"}>002</MenuItem>
                  <MenuItem value={"24"}>003</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Type"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Client Name"
                variant="outlined"
                className="textarea"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  CD Balance
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="CD Balance"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">SPOC</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="SPOC"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="  Status"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Active Policies
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label=" Active Policies"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Total Employees
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label=" Total Employees"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ textAlign: "center" }}
              className="ctaBtn"
            >
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Grid item xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">Clients</h3>
        <SearchBox />
      </Grid>
      <Grid item xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        <Link
          underline="none"
          className="blueBtn upload"
          onClick={() => {
            navigate(ALL_ROUTES.BULK_UPLOAD_PAGE);
          }}
        >
          Bulk Upload
        </Link>
        {/* <Link
          
          underline="none"
          className="blueBtn upload"
          onClick={() => setUploadFile(true)}>
          Bulk Upload
        </Link> */}
        <Link
          underline="none"
          className="blueBtn edit"
          onClick={() => {
            setEditClient(true);
          }}
        >
          Edit
        </Link>
        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            navigate("/AddNewClient");
          }}
        >
          Add New
        </Link>
      </Grid>
      <Grid item xs={12}>
        <div style={{ height: 400, width: "100%" }}>
          <UGTable
            header_data={columns}
            data={rows}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Clients;
